__turbopack_context__.v({
  "list": "destination-filter-widget-module__arwY0W__list",
  "widget": "destination-filter-widget-module__arwY0W__widget",
});
